import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}

(function () {
  const openBtn = document.querySelector('.blog-filter__button');
  const closeBtn = document.querySelector('.blog-filter__close');
  const filterWrap = document.querySelector('.blog-filter__wrap');

  if (!openBtn || !closeBtn || !filterWrap) return;

  openBtn.addEventListener('click', function () {
    filterWrap.classList.add('is-open');
  });

  closeBtn.addEventListener('click', function () {
    filterWrap.classList.remove('is-open');
  });

  document.addEventListener('click', function (e) {
    if (
      filterWrap.classList.contains('is-open') &&
      !filterWrap.contains(e.target) &&
      !openBtn.contains(e.target)
    ) {
      filterWrap.classList.remove('is-open');
    }
  });
})();